/**
 * NotificationFilterTabs - Horizontal filter tabs for notification list
 *
 * Matches Xamarin NotificationListMobile.xaml CollectionView filterList:
 * - Three tabs: All, Task, Trailer
 * - Selected tab: bg TaskHeaderTextColor (#0B2F50), text white
 * - Unselected tab: bg white, border MoreOptionTextColor (#516573), text #516573
 * - Frame: WidthRequest=100, HeightRequest=40, CornerRadius=4, Padding=5, Margin="5,0,0,0"
 * - Label: PoppinsRegular, FontSize=11(Phone), Padding="0,5", HorizontalOptions=Center
 */

import { useTranslation } from 'react-i18next';

import { NOTIFICATION_FILTER } from '@/constants';
import { cn } from '@/utils';

import type { NotificationFilterType } from '@/constants';

interface NotificationFilterTabsProps {
  filters: NotificationFilterType[];
  selectedFilter: NotificationFilterType;
  onFilterChange: (filter: NotificationFilterType) => void;
}

// Map filter constant values to i18n keys
const FILTER_LABEL_KEYS: Record<NotificationFilterType, string> = {
  [NOTIFICATION_FILTER.ALL]: 'notification.filterAll',
  [NOTIFICATION_FILTER.TASK]: 'notification.filterTask',
  [NOTIFICATION_FILTER.TRAILER]: 'notification.filterTrailer',
};

export function NotificationFilterTabs({
  filters,
  selectedFilter,
  onFilterChange,
}: NotificationFilterTabsProps) {
  const { t } = useTranslation();

  return (
    /* Matches Xamarin: CollectionView ItemsLayout=HorizontalList */
    <div className="flex">
      {filters.map((filter) => {
        const isSelected = filter === selectedFilter;
        return (
          /* Matches Xamarin: Frame WidthRequest=100, HeightRequest=40, CornerRadius=4,
             Padding=5, Margin="5,0,0,0", BorderColor=MoreOptionTextColor */
          <button
            key={filter}
            onClick={() => {
              onFilterChange(filter);
            }}
            className={cn(
              'ml-[5px] h-[40px] w-[160px] rounded-[4px] border p-[5px] font-poppins text-[14px]',
              'flex items-center justify-center',
              'transition-colors',
              isSelected
                ? 'border-task-header-text bg-task-header-text text-white'
                : 'border-more-option-text bg-white text-more-option-text'
            )}
          >
            {t(FILTER_LABEL_KEYS[filter])}
          </button>
        );
      })}
    </div>
  );
}
